import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { dashboardService } from '../api/dashboard.service';
import { DASHBOARD_KEYS } from './queryKeys';
import type { DashboardShell, WidgetScope } from '../types';

export function useDashboard(scope: WidgetScope) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  const scopeId =
    scope.type === 'project'
      ? (scope.projectId ?? '')
      : scope.type === 'board'
        ? (scope.boardId ?? '')
        : scope.tenantId;

  return useQuery({
    queryKey: DASHBOARD_KEYS.shell(orgId ?? '', scope.type, scopeId),
    queryFn: ({ signal }) => dashboardService.getShell(scope.type, scopeId, signal),
    select: (r): DashboardShell => r.data,
    staleTime: 300_000,
    enabled: !!orgId && !!scopeId,
  });
}
